import { useCallback } from 'react';

const KEY = 'allviews.hostActiveEventId';

/** Read/write the host's last-selected event id in localStorage so
 *  navbar and deep-linked pages can share context. */
export function useActiveHostEvent() {
  const get = useCallback(() => {
    try { return localStorage.getItem(KEY) || ''; } catch { return ''; }
  }, []);

  const set = useCallback((id) => {
    try { if (id) localStorage.setItem(KEY, id); } catch {}
  }, []);

  return { getActiveEventId: get, setActiveEventId: set };
}
